<template>
  <div
    class="flex flex-col items-center justify-center w-full bg-black"
  >
    <div
      class="w-full h-screen card sm:rounded-xl flex flex-col items-center bg-white overflow-scroll scrollbar-hide shadow-sm"
    >
      <div
        class="w-full bg-primary-blue-10 mb-6 flex items-center justify-center text-center py-2 rounded-t-xl"
      >
        <BaseText
          type="body"
          size="xs"
          class="text-primary-blue-100"
        >
          Start your 7-day free trial. No credit card required
        </BaseText>
      </div>
      <!-- Brand -->
      <div
        class="flex flex-col w-full px-4 pb-4"
      >
        <img
          src="../../assets/images/brief-foreplay-icon.svg"
          alt=""
          class=" h-10"
        >
        <form
          class="mt-5"
          @submit.prevent="checkForm"
        >
          <BaseInputV2
            v-model="fullName"
            placeholder="John Smith"
            label="Full name"
            class=" bg-white rounded-md"
            :errored="errors.includes('Full Name required.')"
            :error-message="'Full Name required.'"
            :class="errors.includes('Full Name required.') ? 'mb-0' : 'mb-4'"
            @input="removeError('Full Name required.')"
          />

          <BaseInputV2
            v-model="email"
            placeholder="hello@gmail.com"
            label="Email"
            class="bg-white rounded-md"
            input-type="email"
            :errored="errors.includes('Email required.')"
            :error-message="'Email required.'"
            :class="errors.includes('Email required.') ? 'mb-0' : 'mb-4'"
            @input="removeError('Email required.')"
          />

          <BaseText
            type="label"
            size="sm"
            class="text-text-muted mb-1"
          >
            Password
          </BaseText>

          <div
            class="relative"
            :class="passwordError ? 'mb-0' : 'mb-4'"
          >
            <input
              v-model="password"
              :type="showPassword ? 'text' : 'password'"
              class="input-container input-container-blue rounded-md px-3 w-full border-border-hover bg-white py-1.5 transition-all ease-in duration-75 focus-within:border-blue-500 placeholder-text-subdued text-body-sm focus:outline-none text-text-loud outline-none"
              :class="{ 'errored': passwordError}"
              placeholder="•••••••••"
              autocomplete
              @input="removeError('Password')"
            >
            <div
              class="absolute inset-y-0 right-0 flex items-center pr-3 cursor-pointer"
              @click="showPassword= !showPassword"
            >
              <svg
                v-if="showPassword"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                class="h-4"
              >
                <path
                  d="M9.16536 4.42071C8.76872 4.5401 8.54397 4.95841 8.66335 5.35505C8.78273 5.75169 9.20105 5.97645 9.59768 5.85706L9.16536 4.42071ZM21.529 11.1176L22.1806 10.7462V10.7462L21.529 11.1176ZM19.1413 14.9666C18.8678 15.2776 18.8982 15.7515 19.2092 16.0251C19.5203 16.2986 19.9942 16.2682 20.2677 15.9571L19.1413 14.9666ZM21.5297 12.8811L20.8781 12.5098L20.8781 12.5098L21.5297 12.8811ZM3.28029 2.21967C2.9874 1.92678 2.51253 1.92678 2.21963 2.21967C1.92674 2.51256 1.92674 2.98744 2.21963 3.28033L3.28029 2.21967ZM2.47016 11.1188L3.12179 11.4901H3.12179L2.47016 11.1188ZM20.7196 21.7803C21.0125 22.0732 21.4874 22.0732 21.7803 21.7803C22.0732 21.4874 22.0732 21.0126 21.7803 20.7197L20.7196 21.7803ZM2.47125 12.8829L1.81966 13.2543H1.81966L2.47125 12.8829ZM10.2322 10.2322C10.5251 9.93934 10.5251 9.46447 10.2322 9.17157C9.9393 8.87868 9.46443 8.87868 9.17153 9.17157L10.2322 10.2322ZM14.8284 14.8284C15.1213 14.5355 15.1213 14.0607 14.8284 13.7678C14.5355 13.4749 14.0606 13.4749 13.7677 13.7678L14.8284 14.8284ZM9.59768 5.85706C13.5394 4.67067 17.9939 6.42962 20.8774 11.489L22.1806 10.7462C19.0295 5.21732 13.9174 2.99041 9.16536 4.42071L9.59768 5.85706ZM20.2677 15.9571C20.9622 15.1674 21.6043 14.2652 22.1814 13.2524L20.8781 12.5098C20.3482 13.4398 19.7644 14.258 19.1413 14.9666L20.2677 15.9571ZM20.8774 11.489C21.0579 11.8057 21.058 12.1942 20.8781 12.5098L22.1814 13.2524C22.6242 12.4754 22.6229 11.5222 22.1806 10.7462L20.8774 11.489ZM2.21963 3.28033L5.99934 7.06003L7.06 5.99937L3.28029 2.21967L2.21963 3.28033ZM3.12179 11.4901C4.21375 9.57383 5.53387 8.13258 6.95695 7.14609L6.10238 5.91332C4.47301 7.04281 3.00749 8.66097 1.81853 10.7475L3.12179 11.4901ZM5.99934 7.06003L16.9399 18.0006L18.0005 16.9399L7.06 5.99937L5.99934 7.06003ZM16.9399 18.0006L20.7196 21.7803L21.7803 20.7197L18.0005 16.9399L16.9399 18.0006ZM1.81966 13.2543C3.74764 16.6368 6.40542 18.7894 9.29529 19.6173C12.1917 20.4471 15.2481 19.9232 17.8975 18.0866L17.0429 16.8539C14.7434 18.4479 12.1496 18.8747 9.7084 18.1753C7.26065 17.4741 4.8934 15.6178 3.12283 12.5115L1.81966 13.2543ZM1.81853 10.7475C1.37557 11.5249 1.37752 12.4786 1.81966 13.2543L3.12283 12.5115C2.94218 12.1946 2.9421 11.8055 3.12179 11.4901L1.81853 10.7475ZM12 14.5C10.6192 14.5 9.49996 13.3807 9.49996 12H7.99996C7.99996 14.2091 9.79082 16 12 16V14.5ZM9.49996 12C9.49996 11.3094 9.77896 10.6855 10.2322 10.2322L9.17153 9.17157C8.4485 9.89461 7.99996 10.8956 7.99996 12H9.49996ZM13.7677 13.7678C13.3145 14.221 12.6905 14.5 12 14.5V16C13.1043 16 14.1054 15.5515 14.8284 14.8284L13.7677 13.7678Z"
                  fill="black"
                />
              </svg>
              <svg
                v-else
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                class="h-4"
              >
                <path
                  d="M2.47032 11.1187L1.81869 10.7474H1.81869L2.47032 11.1187ZM21.5298 11.1188L22.1814 10.7475V10.7475L21.5298 11.1188ZM2.47032 12.8811L1.81869 13.2524H1.81869L2.47032 12.8811ZM21.5298 12.8812L22.1814 13.2526V13.2526L21.5298 12.8812ZM3.12194 11.49C5.43733 7.42677 8.76885 5.49998 12 5.5C15.2312 5.50002 18.5627 7.42687 20.8781 11.4901L22.1814 10.7475C19.6579 6.31907 15.8791 4.00003 12 4C8.12093 3.99997 4.34216 6.31896 1.81869 10.7474L3.12194 11.49ZM1.81869 13.2524C4.34216 17.6809 8.12092 19.9999 12 19.9999C15.8791 20 19.6579 17.681 22.1814 13.2526L20.8781 12.5099C18.5627 16.5732 15.2312 18.5 12 18.4999C8.76886 18.4999 5.43733 16.5731 3.12194 12.5098L1.81869 13.2524ZM1.81869 10.7474C1.37619 11.5239 1.37619 12.4759 1.81869 13.2524L3.12194 12.5098C2.94177 12.1936 2.94177 11.8062 3.12194 11.49L1.81869 10.7474ZM20.8781 11.4901C21.0583 11.8063 21.0583 12.1937 20.8781 12.5099L22.1814 13.2526C22.6239 12.476 22.6239 11.524 22.1814 10.7475L20.8781 11.4901ZM14.5 12C14.5 13.3807 13.3807 14.5 12 14.5V16C14.2092 16 16 14.2091 16 12H14.5ZM12 14.5C10.6193 14.5 9.50004 13.3807 9.50004 12H8.00004C8.00004 14.2091 9.7909 16 12 16V14.5ZM9.50004 12C9.50004 10.6193 10.6193 9.5 12 9.5V8C9.7909 8 8.00004 9.79086 8.00004 12H9.50004ZM12 9.5C13.3807 9.5 14.5 10.6193 14.5 12H16C16 9.79086 14.2092 8 12 8V9.5Z"
                  fill="black"
                />
              </svg>
            </div>
          </div>
          <div
            v-if="passwordError"
            class="py-1 flex items-center mt-1.5 text-secondary-red-100 mb-1"
          >
            <img
              src="../../assets/icons/warning.svg"
              class="mr-1"
            >
            <BaseText
              type="body"
              size="xs"
            >
              {{ passwordErrorMessage }}
            </BaseText>
          </div>
          <div
            id="recaptcha-container"
            ref="recaptchaContainer"
            class="mb-4"
          />
          <BaseButton
            primary
            class="w-full"
            :disabled="loadingEmailLink || !recaptchaVerified"
            :loading="loadingEmailLink"
            type="submit"
          >
            <BaseText
              type="label"
              size="sm"
            >
              Sign up
            </BaseText>
          </BaseButton>
        </form>
        <div
          class="flex items-center gap-6 my-2"
        >
          <div class="border-t border-border-normal flex-1" />
          <BaseText
            type="label"
            size="sm"
            class="text-text-subdued"
          >
            OR
          </BaseText>
          <div class="border-t border-border-normal flex-1" />
        </div>
        <!-- Login Button -->
        <BaseButton
          outlined
          @click="loginUserWithGoogle"
        >
          <div
            class="flex items-center gap-x-2"
          >
            <img
              src="../../assets/images/google-logo.png"
              class="w-3.5"
            >
            <BaseText
              type="label"
              size="sm"
            >
              Sign up with Google
            </BaseText>
          </div>
        </BaseButton>
        <router-link
          class="text-primary-blue-100 hover:text-primary-blue-200 underline mt-4 w-max transition-colors duration-75 ease-out"
          to="/login"
        >
          <BaseText
            type="label"
            size="sm"
          >
            Click here to log in
          </BaseText>
        </router-link>
      </div>
      <BaseText
        type="body"
        size="xs"
        class="text-text-muted w-full text-center pb-4 px-4 mt-auto"
      >
        By clicking one of the buttons above, you agree to our <a
          href="https://www.foreplay.co/page/terms-of-service"
          target="_blank"
          class="text-primary-blue-100"
        > Terms and Conditions </a> and confirm that you have read our <a
          href="https://www.foreplay.co/page/privacy-policy"
          target="_blank"
          class="text-primary-blue-100"
        >Privacy Policy</a>.
      </BaseText>
    </div>
    <video
      id="9af89768-fe35-2d2e-078f-3e5c86a4b569-video"
      autoplay=""
      loop=""
      style="background-image:url(../../assets/videos/account-background.mp4)"
      muted=""
      playsinline=""
      class="absolute h-screen w-full object-fill"
    ><source
      src="../../assets/videos/account-background.mp4"
    ></video>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import store from '../../store'
import firebase from '@/api/config/FirebaseConfig'
// Agency, Brand, Software Company, UGC Creator, Other

export default {
  name: 'SignUpView',
  data () {
    return {
      fullName: null,
      email: null,
      password: null,
      loadingEmailLink: false,
      showPassword: false,
      companyTypes: [{ name: 'Agency' }, { name: 'Brand' }, { name: 'Software Company' }, { name: 'Other' }],
      selectedCompanyType: [],
      errors: [],
      timeoutId: null,
      recaptchaVerified: false,
      recaptchaVerifier: null,
      recaptchaWidgetId: null
    }
  },
  computed: {
    passwordError () {
      return this.errors.some(error => error === 'Password required.') || this.errors.some(error => error === 'Password must be 6 or more characters.')
    },
    passwordErrorMessage () {
      return this.errors.some(error => error === 'Password required.') ? 'Password required.' : 'Password must be 6 or more characters.'
    }
  },
  async mounted () {
    window.Intercom('boot', {
      app_id: process.env.VUE_APP_INTERCOM_ID,
      hide_default_launcher: true
    })
    window.Intercom('hide')
    // get utm_source, utm_medium, utm_campaign from store
    const utmSource = store.getters['MiscModule/getUtmSource']
    const utmMedium = store.getters['MiscModule/getUtmMedium']
    const utmCampaign = store.getters['MiscModule/getUtmSource']
    clearTimeout(this.timeoutId)
    this.timeoutId = setTimeout(() => {
      window.analytics.page('SignUp Page Viewed', {
        pathname: window.location.pathname,
        path: window.location.pathname,
        referrer: window.location.href,
        utmCampaign: utmCampaign || '',
        utmSource: utmSource || '',
        utmMedium: utmMedium || ''

      })
    }, 5000)
    // Setup reCAPTCHA
    this.setupRecaptcha()
  },
  beforeDestroy () {
    window.Intercom('update', {
      hide_default_launcher: false
    })
    // Reset recaptcha if it exists
    if (this.recaptchaVerifier) {
      this.recaptchaVerifier.clear()
    }
  },
  methods: {
    ...mapActions('AuthModule', ['loginUserWithGoogle', 'signUpWithEmailAndPassword']),
    setupRecaptcha () {
      // Initialize reCAPTCHA verifier
      this.recaptchaVerifier = new firebase.auth.RecaptchaVerifier('recaptcha-container', {
        size: 'normal',
        callback: (response) => {
          // reCAPTCHA solved, allow signUp
          this.recaptchaVerified = true
        },
        'expired-callback': () => {
          // Reset reCAPTCHA
          this.recaptchaVerified = false
        }
      })
      // Render the reCAPTCHA widget
      this.recaptchaWidgetId = this.recaptchaVerifier.render()
    },
    removeError (error) {
      this.errors = this.errors.filter(e => e !== error)
    },
    // Send Email Link
    async checkForm (e) {
      this.errors = []

      if (!this.fullName) {
        this.errors.push('Full Name required.')
      }
      if (!this.email) {
        this.errors.push('Email required.')
      }
      if (!this.password) {
        this.errors.push('Password required.')
      }
      if (this.password && this.password.length < 6) {
        this.errors.push('Password must be 6 or more characters.')
      }
      if (!this.recaptchaVerified) {
        this.errors.push('Please complete the reCAPTCHA verification.')
        return
      }
      // if (!this.selectedCompanyType.length) {
      //   this.errors.push('Company Type required.')
      // }

      if (!this.errors.length) {
        await this.signUpUser()
      }

      e.preventDefault()
    },
    async signUpUser () {
      this.loadingEmailLink = true

      try {
        const payload = {
          email: this.email,
          password: this.password,
          name: this.fullName,
          recaptchaToken: await this.recaptchaVerifier.verify()
        }

        payload.firstName = this.fullName.split(' ')[0]
        if (this.fullName.split(' ')[1]) {
          payload.lastName = this.fullName.split(' ')[1]
        }
        await this.signUpWithEmailAndPassword(payload)
        // Track email/pass signups
        if (payload?.email) {
          window.dataLayer.push({
            event: 'app_sign_up',
            user_data: {
              email_address: payload.email
            }
          })
        }
      } catch (e) {
        console.log(e)
        this.$showAlert({
          message: e.message,
          type: 'error'
        })
        // Reset reCAPTCHA on error
        this.recaptchaVerified = false
        this.recaptchaVerifier.reset(this.recaptchaWidgetId)
      } finally {
        this.loadingEmailLink = false
      }
    }
  },
  metaInfo: {
    title: 'Create Your Foreplay Account | Foreplay.co',
    link: [
      { rel: 'canonical', href: 'https://app.foreplay.co/sign-up' }
    ]
  }

}

</script>

<style scoped>
.input-container {
  box-shadow: 0px 1px 2px rgba(18, 55, 105, 0.08), 0px 0px 0px 1px rgba(18, 55, 105, 0.08);
}
.input-container-blue:focus-within {
  outline: 2px solid #1F69FF50;
  outline-offset: 1.5px;
}

.errored {
  box-shadow: 0px 1px 2px rgba(150, 19, 44, 0.32), 0px 0px 0px 1px rgba(221, 3, 45, 0.9), 0px 0px 0px 2px #FFFFFF, 0px 0px 0px 4px rgba(223, 28, 65, 0.24);
}

.card{
  animation: none;
  z-index: 10;
}

@media (min-width: 640px) {
  .card {
    animation: none;
    max-width: 470px;
    max-height: 600px;
  }
}

</style>
